module.exports = __webpack_public_path__ + "img/clients-enabled.85830f2c.svg";